import CardGrid from './CardGrid';

export default CardGrid;
